import {forEach, filter, remove, slice, findIndex, countBy, each, keys} from 'lodash';
import app from '../../angular_app.es6';
import {Uppy} from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import ThumbnailGenerator from "@uppy/thumbnail-generator";

app.controller('AddingNamingController',
  [ '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope', '$location', 'PasteTableService',
    ($scope, Notification, $timeout, $http, $element, $interval, $rootScope, $location, PasteTableService) => {
      const forceEditParam = 'edit',
        checkInterval = 5000;
      let checkEvery5s = null;
      $scope.newName = {};

      $scope.form = {};
      $scope.source_form = {};
      $scope.options = {};

      $scope.init = (data, options, notification) => {
        $rootScope.$broadcast('hideExamples');

        $scope.form = angular.copy(data);
        $scope.source_form = data;
        $scope.options = options;
        $scope.notification = notification;
        $scope.asyncGenerateJID = $scope.options.jid;
        $scope.maxConcepts = $scope.options.max_concepts;

        if ($scope.asyncGenerateJID) {
          checkEvery5s = $interval($scope.checkAsyncGenerate, checkInterval);
          $rootScope.$broadcast('disableNavButtons');
        }

        if ($scope.notification) {
          $scope.startEdit();
          Notification.error($scope.notification);
        }
        $scope.refreshTempItem();
      };

      $scope.maxToUpload = () => (Math.abs($scope.notDeletedNames().length - $scope.maxConcepts));

      $scope.$watch('form.concepts_mode', (newValue) => {
        $scope.form.min = (newValue === 'sequential' ? 2 : 1);
      }, true);

      $scope.refreshTempItem = () => {
        $scope.newName = { id: null, name: null };
      };

      $scope.noNames = () => {
        const emptyList = !$scope.notDeletedNames().length;
        if (emptyList) {
          $rootScope.$broadcast('hideExamples');
        } else {
          $rootScope.$broadcast('showExamples');
        }
        return emptyList;
      };

      $scope.isEditing = () => (!$scope.noNames() || !!$location.search()[forceEditParam]);

      $scope.startEdit = () => {
        $location.search(forceEditParam, '1');
      };

      $scope.reachedMax = () => ($scope.notDeletedNames().length >= $scope.maxConcepts);

      $scope.disabledNew = () => ($scope.reachedMax() || !$scope.newName || !$scope.newName.name);

      $scope.addName = (event) => {
        event.preventDefault();
        $scope.form.express_images.push($scope.newName);
        $scope.refreshTempItem();
      };

      $scope.destroyName = (event, claim) => {
        event.preventDefault();
        if (claim.id) {
          claim._destroy = true;
        } else {
          remove($scope.form.express_images, claim);
        }
      };

      $scope.notDeletedNames = () => (
        filter($scope.form.express_images, (claim) => !claim._destroy)
      );

      $scope.hasTextError = (claim) => (
        claim.errors && !!claim.errors.text
      );

      $scope.$on('xlsx-loaded', (ev, arr) => {
        const newElms = [];

        forEach(arr, (el) => {
          let text = el[arr.headerStatement];

          if (text) {
            text = text.toString();
            newElms.push(
              {
                id: null,
                name: slice(text, 0, $scope.form.max_text_len).join('')
              }
            );
          }
        });

        const toCopyCnt = $scope.maxConcepts - $scope.notDeletedNames().length;

        if (toCopyCnt > 0) {
          $timeout(() => {
            forEach(
              slice(newElms, 0, toCopyCnt),
              (el) => { $scope.form.express_images.push(el); }
            );
          });
        }
      });

      $scope.onImageSelected = (claim) => (
        (file) => { claim.loading = true; }
      );

      $scope.onImageUploaded = (claim) => {
        if (!claim.onImageUploaded) {
          claim.onImageUploaded = (source) => {
            const source_json = JSON.parse(source['source_data']);
            if (source_json.metadata.mime_type === "application/pdf") {
              $http.post(
                '/express/api/transformer',
                {
                  project_id: $scope.form.id,
                  source_data: source['source_data']
                }
              ).then(
                (response) => {
                  watchConvertStatus(source, response.data.jid);
                },
                (response) => {
                  Notification.error(response.data.error || response.statusText);
                  $scope.destroyObject(null, source);
                }
              );
            } else {
              source['image_data'] = source['source_data'];
              source['image_src'] = source['preview_src'];
              Object.merge(source, { loading: false });
            }
          };
        }
        return claim.onImageUploaded;
      };

      $scope.openUploader = (event, parentPath, path) => {
        event.preventDefault();
        $(event.target).parents(parentPath).find(path).click();
      };

      $scope.nullifyImage = (flavor) => {
        let i;
        const keys = Object.keys(flavor);

        for (i = 0; i < keys.length; i++) {
          if (keys[i] !== 'id' && keys[i] !== 'name') {
            delete flavor[keys[i]];
          }
        }

        $timeout(() => {});
      };

      $scope.onUploadSuccess = (source) => {
        const source_json = JSON.parse(source['source_data']);
        source['name'] = $scope.removeExtension(source_json.metadata.filename);

        if (source_json.metadata.mime_type === "application/pdf") {
          $http.post(
            '/express/api/transformer', {
              project_id: $scope.form.id,
              source_data: source['source_data']
            }
          ).then(
            (response) => {
              watchConvertStatus(source, response.data.jid);
            },
            (response) => {
              Notification.error(response.data.error || response.statusText);
              $scope.destroyObject(null, source);
            }
          );
        } else {
          source['image_data'] = source['source_data'];
          source['image_src'] = source['preview_src'];
          Object.merge(source, { loading: false });
        }
      };

      $scope.sourceGenerator = () => ({ id: null, image_src: '#' });

      $scope.removeExtension = (filename) => {
        return (filename || '').split('.').slice(0, -1).join('.');
      };

      const watchConvertStatus = (source, jid) => {
        (function tick() {
          $http.get(`/express/api/transformer/${jid}`).then(
            (response) => {
              const state = response.data.state;
              if (response.data.status === 'failed') {
                state.step = 'error';
                state.message = `Something went wrong while processing the '${source.name}' at the moment, please try again`;
              }

              switch (state.step) {
                case 'finished':
                  Object.merge(source, state.output);
                  Object.merge(source, { loading: false });
                  break;
                case 'error':
                  $scope.destroyObject(null, source);
                  Notification.error(state.message);
                  break;
                default:
                  $timeout(tick, 3000);
              }
            },
            (response) => {
              Notification.error(response.data.error || response.statusText);
            }
          );
        })();
      };

      $scope.isLoading = () => (
        findIndex(
          ($scope.form.express_images || []),
          (img) => img.loading
        ) > -1
      );

      $scope.$watch('isLoading()', (newVal) => {
        if (!$scope.asyncGenerateJID) {
          if (newVal) {
            $rootScope.$broadcast('disableNavButtons');
          } else {
            $rootScope.$broadcast('enableNavButtons');
          }
        }
      });

      // private

      $scope.checkAsyncGenerate = () => {
        $http.get($scope.options.check_status_url).then(
          (success) => {
            if (success.data.status === "finished") {
              $interval.cancel(checkEvery5s);
              $scope.asyncGenerateJID = null;
              window.location.href = $scope.options.next_step_url;
            } else if (success.data.status === "failed") {
              $scope.asyncGenerateJID = null;
              $interval.cancel(checkEvery5s);
              Notification.error("Project rebuilding failed.");
              $rootScope.$broadcast('enableNavButtons');
            }
          },
          (reject) => {
            $interval.cancel(checkEvery5s);
            $scope.asyncGenerateJID = null;
            console.log('checkAsyncGenerate', reject);
            $rootScope.$broadcast('enableNavButtons');
          }
        );
      };


      $scope.$on('project-form-next-step', (event) => {
        if ($scope.asyncGenerateJID) {
          event.preventDefault();
          Notification.error("Rebuilding in progress.");
          return;
        }

        const form = $('#adding_form');

        if (!$scope.options.need_generate) {
          form.submit();
        } else if (!trackChanges() && trackExisting() && !$scope.notification) {
          event.preventDefault();
          window.location.href = $scope.options.next_step_url;
        } else if (!trackExisting()) {
          form.submit();
        } else if (confirm($scope.options.change_structure_message)) {
          form.submit();
        }
      });

      const trackExisting = () => (
        !!filter($scope.form.express_images, (el) => !!el.id).length
      );

      const trackChanges = () => (
        !angular.equals($scope.form, $scope.source_form)
      );

      $scope.onPaste = ($e, index) => {
        const lines = PasteTableService.extract($e);
        if (lines != null) {
          PasteTableService.apply(
            index,
            $scope.notDeletedNames(),
            [ 'name' ],
            lines,
            $scope.form.express_images,
            $scope.maxConcepts,
            () => ({ id: null, name: null })
          );
        }
      };
    } ]);
